import React, { useEffect, useState } from 'react';
import { useListContext } from 'framework/list';
import { Fade, Loading } from 'framework/ui/mui-builder';
import { Box } from '@mui/material';

const KpiValueLayout = ({ filter, children }: { filter: React.ReactNode; children: React.ReactNode }) => {
  const { data, loading } = useListContext();
  const [mapLoading, setMapLoading] = useState(true);

  useEffect(() => {
    setMapLoading(true);
  }, [loading]);

  useEffect(() => {
    if (data) {
      setMapLoading(false);
    }
  }, [data]);

  if (loading || mapLoading) {
    return <Loading />;
  }

  return (
    <Fade in={!loading && !mapLoading} timeout={20}>
      <Box padding="16px">
        <Box display="flex" justifyContent="space-between" marginBottom="16px">
          <Box display="flex" alignItems="center">
            {filter}
          </Box>
        </Box>
        {children}
      </Box>
    </Fade>
  );
};

export default KpiValueLayout;
